import React, { useState, useCallback, useEffect, useMemo } from 'react'
import Scheduler from './scheduler';
import ReservationInfo from './reservation'
import { Sidebar, Segment, Menu, Modal, Checkbox, Message, Icon, Divider } from 'semantic-ui-react';
import { GetRooms, SaveReservation, UpdateReservationStatus, GetReservationTotals, GetDataForRestrictionsPageNew, GetProductPricesForCalendar } from '../../api/services/pms'
import { GetFullName, getContrastYIQ } from '../../components/shared/utils'
import _, { uniqueId } from 'lodash'
import Moment from 'moment'
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import './style.less'
import { isMobileOnly } from 'mobile-device-detect';
import ShortReservationPopup from '../../components/ShortReservationPopup';
import RoomMaintenancePopup from '../../components/RoomMaintenancePopup';
import { MaintenanceStatusTypes } from './statustypes';
import { useTextResources } from '../../language';
import { GetHotels } from '../../api/services/organization';
import { ReservationStatusesEnums } from '../../components/shared/statustypes';
import { CleanReservationProps } from '../../components/shared/reservation';
import { Actions, RestrictionTypes } from '../../components/shared/constants';
import { Fab, Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import RestrictionsPopup from '../../components/RestrictionsPopup';
import PriceUpdatePopup from '../../components/PriceUpdatePopup';
import { onError } from '../../components/shared/messages';
import { onWarning } from '../../components/shared/messages';
import HotelsDropDown from '../../components/shared/HotelsDropDown';
import ValidateModalPermission from '../../components/shared/ValidateModalPermission'
import { PermissionsActions } from '../../components/shared/permissionsActions'
import { Calendar, Hotels, RoomPlannedMaintenance, Rooms, RoomTypes, Wings } from '../../api/services/next'
import { useLoader } from '../../hooks/useLoader';

// Initialize default calendar settings
const initCalendarSettings = {
  reservationIcon: "24h",
  showYield: false,
  showHoliday: true,
  showComments: true,
  showOccupancy: true,
  showHouseKeeping: false,
  showReservationNumber: false
}
let calendarSettings = localStorage.getItem("CalendarSettings")
calendarSettings = calendarSettings ? {
  ...initCalendarSettings,
  ...JSON.parse(calendarSettings)
} : initCalendarSettings
let calendarHotelSettings = localStorage.getItem("CalendarHotelSettings")
calendarHotelSettings = calendarHotelSettings ? JSON.parse(calendarHotelSettings) : {}


const TapeChart = () => {
  const text = useTextResources()
  const loader = useLoader()
  const [showInfo, setShowInfo] = useState(false)
  const [hotels, setHotels] = useState()
  const [rooms, setRooms] = useState()
  const [roomtypes, setRoomTypes] = useState()
  const [wings, setWings] = useState()
  const [selected, setSelected] = useState({})
  const [showCreateMenu, setShowCreateMenu] = useState(false)
  const [showShortReservation, setShowShortReservation] = useState(false)
  const [showRoomMaintenance, setShowRoomMaintenance] = useState(false)
  const [reservationForEdit, setReservationForEdit] = useState(null)
  const [maintenanceForEdit, setMaintenanceForEdit] = useState(null)
  const [selectionInfo, setSelectionInfo] = useState(null)
  const [viewSettings, setViewSettings] = useState(calendarSettings)
  const [hotelSettings, setHotelSettings] = useState(calendarHotelSettings)
  const [selectionAsDefault, setSelectionAsDefault] = useState(localStorage.getItem("DefaultCalendarCreateItem") !== null)
  const [selectedHotelIds, setSelectedHotelIds] = useState([]);
  const [reservationVisible, setReservationVisible] = useState(false)
  const canEdit = window.optima?.user ? window.optima.user.ActionIDs.includes(Actions.EditCalendar) : true

  const hotelsWithRooms = useMemo(() => {
    if (!hotels || !rooms) {
      return [];
    }

    return _.filter(hotels, (hotel) => {
      return _.some(rooms, (room) => room.HotelId === hotel.Id);
    });
  }, [hotels, rooms])

  const HotelFilterCmp = useCallback(() => {
    return (
      <HotelsDropDown
        multiple
        onChange={setSelectedHotelIds}
        data={hotelsWithRooms}
        placeholder={text("All")}
        search
        clearable
        style={{ minWidth: '130px' }}
      />
    );
  }, [hotelsWithRooms, text]);

  useEffect(() => {
    if (window.BroadcastChannel) {
      const bc = new BroadcastChannel('optima');
      bc.onmessage = message => {
        const data = message.data
        if (data.type && data.type === "FolioUpdated") {
          window.calendar.refetchEvents()
        }
      }
    }
  }, [])

  useEffect(() => {
    (async () => {
      loader(true)
      const hotels = await Hotels.GetHotels({
          IsActive: true,
          IncludeOnlyHotelsWithUserPermissions: true,
          includes: ['HotelFeatures', 'Location']
      })
      const rooms = await Rooms.GetRooms()
      const roomtypes = await RoomTypes.GetRoomTypes();
      const wings = await Wings.GetWings();
      
      setHotels(hotels)
      setRoomTypes(roomtypes)
      setWings(wings)
      setRooms(rooms)
      loader(false)
    })()
  }, [])

  const resourcesFunction = useCallback(async (fetchInfo, successCallback, failureCallback) => {
    if (hotels && rooms && roomtypes && wings) {
      // const data = await Calendar.GetHotelDateParameters({
      //   HotelIds: hotels.map(x => x.Id),
      //   FromDate: fetchInfo.startStr,
      //   ToDate: fetchInfo.endStr
      // })

      loader(true)

      let resources = rooms.filter(room =>
        !selectedHotelIds.length || selectedHotelIds.includes(room.HotelId)).map(room => {
        const hotel = hotels.find(hotel => hotel.Id === room.HotelId)
        //const hotelData = data.filter(d => d.HotelId === room.HotelId)
        const hotelData = []
        const roomtype = roomtypes.find(type => type.Id === room.TypeId)
        const wing = wings.find(wing => wing.Id === room.WingId)
        
        // Skip if hotel, roomtype, or wing is null
        if (!hotel || !roomtype || !wing) {
          return null;
        }

        return {
          id: room.Id,
          title: `${room.Number}   ${roomtype.Name}`,
          group: `${hotel.Name} (${wing.Name})`,
          extendedProps: { room, hotel, hotelData, wing: wing },
          order: room.DisplayOrder
        }
      }).filter(Boolean)
      successCallback(resources)
      loader(false)
    } else {
      failureCallback()
      loader(false)
    }
  }, [hotels, rooms, roomtypes, selectedHotelIds, wings])
  /* #endregion */

  const refreshSelected = useMemo(() => {
    const sel = selected
    return () => {
      // Since events where updated we should reset the selection
      if (sel.event) {
        const event = window.calendar.getEventById(sel.event.id)
        const el = document.querySelector(`[data-event-id='${sel.event.id}']`)
        setSelected({
          event,
          el
        })
      }
    }
  }, [selected])

  const eta = date => {
    return moment(date).toISOString()
  }
  const etd = date => {
    return moment(date).toISOString()
  }
  const noon = date => {
    return moment(date).hour(12).toISOString()
  }

  const rebuildDayUseEvents = useCallback(originalEvents => {
    const calendar = window.calendar
    if (!calendar) return;
    
    calendar.batchRendering(() => {
      let events
      // Remove any existing virtual events
      if (!originalEvents) {
        events = calendar.getEvents()
        events.forEach(event => {
          const eprop = event.extendedProps
          if (eprop.IsGroupingDayUse) {
            event.remove()
          }
        })
      }

      events = originalEvents || calendar.getEvents()
      // search for dayuse reservations
      let dayuse = events.filter(x => {
        return x.extendedProps.reservation && moment(x.start).isSame(moment(x.end), "day")
      })

      dayuse = _.groupBy(dayuse, x => `${moment(x.start).format("YYYY-MM-DD")}:${x.resourceId || x.getResources()[0].id}`)
      const dayEvents = []
      // Create combined events from dayuse 
      _.forEach(dayuse, (val, key) => {
        const [date, resourceId] = key.split(":")
        dayEvents.push({
          id: key,
          resourceId: Number(resourceId),
          title: `${val.length} ${text("Reservations")}`,
          start: moment(date).startOf("day").toISOString(),
          end: moment(date).startOf("day").toISOString(),
          className: "grouping-event",
          durationEditable: false,
          startEditable: false,
          resourceEditable: false,
          extendedProps: { events: val, IsGroupingDayUse: true }
        })
      })

      dayEvents.forEach(dummy => {
        if (originalEvents) {
          originalEvents.push(dummy)
        } else {
          calendar.addEvent(dummy, "main")
        }
      })
    })
  }, [])

  const createNewReservation = useCallback((info) => {
    setShowCreateMenu(false)
    if (selectionAsDefault) {
      localStorage.setItem("DefaultCalendarCreateItem", "reservation")
    } else {
      localStorage.removeItem("DefaultCalendarCreateItem")
      setSelectionAsDefault(false)
    }
    let CurrentHotel = window.user ? window.user.CurrentHotel : null
    const room = info.resource && info.resource.extendedProps.room;
    const hotel = info.resource ? info.resource.extendedProps.hotel : CurrentHotel;
    const newReservation = {
      Id: 0,
      ...(info.start && {CheckInDate: info.start}),
      ...(info.end && {CheckOutDate: info.end}),
      RoomId: room && room.Id,
      RoomTypeId: room && room.TypeId,
      HotelId: hotel && hotel.Id,
      WingId: room && room.WingId,
      ReservationPricingTypeId: 1,
      CurrencyId: hotel.MainCurrencyId || 1,
      TotalAmountProductCurrentBeforeTax: 0,
      TotalAmountProductCurrentAfterTax: 0,
      Quantity: 1,
      _hotel: hotel,
      totals: null
    }
    if (info.view.type === "resourceTimelineDay") {
      newReservation.Eta = moment(info.start).format("HH:mm:ss")
      newReservation.Edt = moment(info.end).format("HH:mm:ss")
    }
    setReservationForEdit(newReservation)
  }, [selectionAsDefault])

  const createNewMaintenance = useCallback((info) => {
    setShowCreateMenu(false)
    if (selectionAsDefault) {
      localStorage.setItem("DefaultCalendarCreateItem", "maintenance")
    } else {
      localStorage.removeItem("DefaultCalendarCreateItem")
      setSelectionAsDefault(false)
    }
    let CurrentHotel = window.user ? window.user.CurrentHotel : null
    const room = info.resource && info.resource.extendedProps.room;
    const hotel = info.resource ? info.resource.extendedProps.hotel : CurrentHotel;
    setMaintenanceForEdit({
      Id: 0,
      StartDate: info.start,
      EndDate: info.end,
      RoomId: room && room.Id,
      RoomTypeId: room && room.TypeId,
      HotelId: hotel && hotel.Id,
      MaintenanceStatusTypeId: 2
    })
  }, [selectionAsDefault])

  const createRestrictions = useCallback((info) => {
    setShowCreateMenu(false)
    let CurrentHotel = window.user ? window.user.CurrentHotel : null
    const room = info.resource && info.resource.extendedProps.room;
    const hotel = info.resource ? info.resource.extendedProps.hotel : CurrentHotel;
    const settings = hotelSettings[hotel.Id]
    window.RestrictionsController("open", {
      HotelId: hotel && hotel.Id,
      StartDate: info.start,
      EndDate: info.end,
      RoomTypeIds: [room && room.TypeId],
      RateID: settings && settings.selectedRate
    })
  }, [hotelSettings])

  const createPriceUpdate = useCallback((info) => {
    setShowCreateMenu(false)
    let CurrentHotel = window.user ? window.user.CurrentHotel : null
    const room = info.resource && info.resource.extendedProps.room;
    const hotel = info.resource ? info.resource.extendedProps.hotel : CurrentHotel;
    const settings = hotelSettings[hotel.Id]
    window.PriceUpdateController("open", {
      HotelId: hotel && hotel.Id,
      StartDate: info.start,
      EndDate: info.end,
      RoomTypeIds: [room && room.TypeId],
      RateID: settings && settings.selectedRate
    })
  }, [hotelSettings])


  const rebuildVirtualEvents = useCallback(originalEvents => {
    const calendar = window.calendar
    if (!calendar) return;
    calendar.batchRendering(() => {
      let events
      // Remove any existing virtual events
      if (!originalEvents) {
        events = calendar.getEvents()
        events.forEach(event => {
          const eprop = event.extendedProps
          if (eprop.Virtual) {
            event.remove()
          }
        })
      }
      events = originalEvents || calendar.getEvents()
      const nonGroupEvents = events.filter(event => event.extendedProps && !event.extendedProps.IsGroupingDayUse)
      const complexRooms = calendar.getResources().map(x => x.extendedProps.room.IsVirtual ? x.extendedProps.room : null).filter(x => x)
      let dummyEvents = []
      nonGroupEvents.forEach(event => {

        if (event.id === "columndata") {
          return
        }

        const eprop = event.extendedProps
        const resource = event.resourceId ? calendar.getResourceById(event.resourceId) : event.getResources()[0]

        if (!resource) {
          return
        }

        const room = resource.extendedProps.room
        // Create dummy events for virtual room parts (for both reservations AND maintenance)
        if (room.IsVirtual && (eprop.reservation || eprop.maintenance)) {
          room.RoomComplexParts.forEach(part => {
            const dummy = {
              id: uniqueId("complex-"),
              title: event.title,
              start: event.start,
              end: event.end,
              extendedProps: { hotel: eprop.hotel, Virtual: true, maintenance: eprop.maintenance },
              resourceId: part.PartRoomID,
              durationEditable: false,
              startEditable: false,
              resourceEditable: false,
              event: event,
              classNames: eprop.maintenance ? ["complex-part", "maintenance"] : ["complex-part"],
              color: eprop.maintenance ? (eprop.maintenance.Color || "#b7b7b7") : undefined
            }
            dummyEvents.push(dummy)
          })
        } else if (eprop.reservation || eprop.maintenance) {
          // Create dummy events for complex room if the reservation/maintenance is for one of it's parts
          const complexParents = complexRooms.filter(x => _.some(x.RoomComplexParts, part => part.PartRoomID === room.Id))
          complexParents.forEach(complex => {
            const reservationRange = moment.range(event.start, event.end)
            const isEventDayUse = moment(event.start).isSame(moment(event.end), "day")
            const eventsForComplex = dummyEvents.filter(event => event.resourceId === complex.Id)
            let existingEvents = eventsForComplex.filter(x => {
              const range = moment.range(x.start, x.end)
              const isDummyEventDayUse = moment(x.start).isSame(moment(x.end), "day")
              const isInSameDay = isDummyEventDayUse && isEventDayUse && moment(event.start).isSame(moment(x.start), "day")
              return (range.overlaps(reservationRange, { adjacent: true })
                ||
                isInSameDay)
            })

            const dummy = {
              id: uniqueId("complex-"),
              extendedProps: { hotel: eprop.hotel, Virtual: true },
              resourceId: complex.Id,
              durationEditable: false,
              startEditable: false,
              resourceEditable: false,
              event: event,
              classNames: ["complex-part", "complex-dummy"]
            }

            if (existingEvents.length) {
              dummy.start = eta(moment.min([
                ...existingEvents.map(x => moment(x.start)),
                moment(event.start)
              ]))
              dummy.end = etd(moment.max([
                ...existingEvents.map(x => moment(x.end)),
                moment(event.end)
              ]))

              const ids = existingEvents.map(x => x.id)
              _.remove(dummyEvents, x => ids.includes(x.id))
              const extendedEvents = existingEvents[0].extendedProps ? [...existingEvents[0].extendedProps.events, event] :
                [...existingEvents.map(x => x.event), event]
              dummy.title = `${text("Occupied")} [${extendedEvents.length}]`
              dummy.extendedProps.events = extendedEvents
              dummyEvents.push(dummy)
            } else {
              dummy.start = event.start || event.extendedProps.reservation && event.extendedProps.reservation.CheckInDate
              dummy.end = event.end || event.extendedProps.reservation && event.extendedProps.reservation.CheckOutDate
              dummy.extendedProps.events = [event]
              dummy.title = `${text("Occupied")} [1]`
              dummyEvents.push(dummy)
            }
          })
        }
      })
      dummyEvents.forEach(dummy => {
        if (originalEvents) {
          originalEvents.push(dummy)
        } else {
          calendar.addEvent(dummy, "main")
        }
      })
    })
  }, [])

  /* #region  Loading reservations */
  const totalsFunction = async (hotelsWithRooms, data) => {
    let totals = []
    try {
      totals = _.flatMap(await Promise.all(_.map(_.groupBy(_.filter(data, x => !x.MaintenanceStatusTypeId), "HotelId"), (reservations, HotelId) => {
        const hotel = hotelsWithRooms.find(x=>x.Id == HotelId)
        return GetReservationTotals({
          ReservationIDs: _.map(reservations, "Id"),
          HotelId: HotelId,
          TargetCurrencyID: hotel.MainCurrencyId
        })
      })))
      if (totals) {
        const events = window.calendar.getEvents()
        window.calendar.batchRendering(() => {
          events.forEach(event => {
            if (event.extendedProps.reservation) {
              const total = totals.find(x => x.ReservationID === event.extendedProps.reservation.Id)
              event.setExtendedProp("totals", total)
            }
          })
        })
      }
    } catch (error) {
      onWarning(error)
    }
  }

  const eventsFunction = useCallback(async (fetchInfo, successCallback, failureCallback) => {
    if (hotelsWithRooms.length) {
      try {
        const reservations = Calendar.GetReservations({
          HotelIds: hotelsWithRooms.map(x => x.Id),
          FromCheckOutDate: fetchInfo.startStr,
          ToCheckInDate: fetchInfo.endStr,
          AssignedRoomsOnly: true,
          includes: ["Room","Status", "RoomType", "ReservationDailyAccommodations", "ReservationDailyAddons"]
        })

        const maintenance = RoomPlannedMaintenance.GetRoomPlannedMaintenances({
          HotelIds: hotelsWithRooms.map(x => x.Id),
          FromDate: fetchInfo.startStr,
          ToDate: fetchInfo.endStr,
          Includes: ["Room"]
        })
        let events = []

        

        const values = await Promise.all([reservations, maintenance])
        const data = values.flat()

        data.forEach(event => {
          const hotel = hotelsWithRooms.find(x=>x.Id == event.HotelId)
          const room = rooms.find(x=>x.Id == event.RoomId)
          if (event.MaintenanceStatusTypeId) { // Handle maintenance event
            events.push({
              id: event.Id,
              resourceId: event.RoomId,
              title: event.Description ? event.Description.replaceAll("\n", " ") : MaintenanceStatusTypes[event.MaintenanceStatusTypeId],
              start: noon(event.StartDate),
              end: noon(event.EndDate),
              extendedProps: { maintenance: event, hotel: hotel, room: room },
              color: event.Color || "#b7b7b7",
              textColor: getContrastYIQ(event.Color || "3788d8"),
              classNames: "maintenance",
              editable: canEdit
            })
          } else { // Handle reservation event
          }
        });
/*
        totalsFunction(hotelsWithRooms, data)

        let events = _.reduce(data, (result, reservation) => {
          const hotel = hotelsWithRooms.find(x=>x.Id == reservation.HotelId)
          const room = rooms.find(x=>x.Id == reservation.RoomId)
          if (reservation.MaintenanceStatusTypeId) { // Handle maintenance event
            result.push({
              id: reservation.Id,
              resourceId: reservation.RoomId,
              title: reservation.Description ? reservation.Description.replaceAll("\n", " ") : MaintenanceStatusTypes[reservation.MaintenanceStatusTypeId],
              start: noon(reservation.StartDate),
              end: noon(reservation.EndDate),
              extendedProps: { maintenance: reservation, hotel: hotel, room: room },
              color: reservation.Color || "#b7b7b7",
              textColor: getContrastYIQ(reservation.Color || "3788d8"),
              classNames: "maintenance",
              editable: canEdit
            })
          } else { // Handle reservation event
            const rescheckin = reservation.CheckInDate
            const rescheckout = reservation.CheckOutDate
            const IsHomogeneous = _.every(reservation.ReservationDailyAccommodations, ["RoomId", reservation.RoomId])
            const title = viewSettings.showReservationNumber ? `${reservation.Number} ${GetFullName(reservation.Guest)}` : GetFullName(reservation.Guest)
            let classes = ""
            if (selected.event && selected.event.id == reservation.Id) {
              classes += "selected "
            }
            const common = {
              id: reservation.Id,
              title: title,
              extendedProps: { reservation: reservation, hotel: hotel, room: room },
              color: reservation.Color,
              textColor: getContrastYIQ(reservation.Color || "3788d8"),
              editable: canEdit,
              overlap: true
              //durationEditable: reservation.StatusId === ReservationStatusesEnums.Reserved
            }
            if (IsHomogeneous) {
              result.push({
                ...common,
                resourceId: reservation.RoomId,
                start: eta(rescheckin),
                end: etd(rescheckout),
                classNames: classes
              })
            } else {
              const groupped = _.reduce(reservation.ReservationDailyAccommodations, (result, value, index, collection) => {
                if (!index || value.RoomId != collection[index - 1].RoomId) {
                  result.push([])
                }
                result[result.length - 1].push(value);
                return result;
              }, [])

              _.forEach(groupped, (group, idx) => {
                const mindate = _.minBy(group, "Date")
                const maxdate = _.maxBy(group, "Date")
                const roomId = group[0].RoomId;
                const checkin = moment(mindate.Date)
                const checkout = moment(maxdate.Date).add(1, "day")

                if (roomId) {
                  result.push({
                    ...common,
                    id: `${reservation.Id}-${idx}`,
                    resourceId: group[0].RoomId,
                    start: checkin.isSame(rescheckin, "day") ? eta(rescheckin) : noon(checkin),
                    end: checkout.isSame(rescheckout, "day") ? eta(rescheckout) : noon(checkout),
                    classNames: classes + "hetero ",
                    durationEditable: false,
                    startEditable: false,
                    resourceEditable: false
                  })
                }
              })
            }
          }

          return result
        }, [])


        rebuildDayUseEvents(events)

        rebuildVirtualEvents(events)
        */

        successCallback(events)
        //refreshSelected()
      } catch (err) {
        onError(err)
        failureCallback(err)
      } 
    } else {
      failureCallback()
    }
  }, [canEdit, hotelsWithRooms, rooms])

  /* #endregion */

  const dayDataFunction = useCallback(async (fetchInfo, successCallback, failureCallback) => {
    if (hotels && rooms) {
      try {
        const hotelsWithRestrictions = _.filter(hotelsWithRooms, hotel => {
          const settings = hotelSettings[hotel.Id]
          const showSettings = hotel.HotelFeatures.find(feature => feature.FeatureID === 12)
          return settings && settings.showRestrictions && showSettings
        })
        let promises = _.map(hotelsWithRestrictions, hotel => {
          const settings = hotelSettings[hotel.Id]
          return GetDataForRestrictionsPageNew({
            HotelID: hotel.Id,
            StartDate: fetchInfo.startStr,
            EndDate: fetchInfo.endStr,
            RateID: settings && settings.selectedRate,
            IncludeRoomType: true,
            FlattenRoomTypeId: true
          })
        })
        const values = await Promise.all(promises)

        // Group all restrictions by date
        const data = _.groupBy(_.flatMap(values), "Date")

        let events = [];
        _.forEach(data, (datedata, date) => {
          let resdata = datedata.reduce((res, val) => {
            res.push(...val.Restrictions)
            return res
          }, [])
          resdata = _.groupBy(resdata, x => {
            if (x.RoomTypeId) return `${x.HotelID}:${x.RoomTypeId}`;
            else return undefined;
          })

          //check if there r hotel level restrictions
          const noRoomTypeIdRestrictions = resdata[undefined];

          const hotelLevelRestrictions = noRoomTypeIdRestrictions ?
            noRoomTypeIdRestrictions.filter(v => !v.RateId && !v.ProductID && !v.RoomTypeId) :
            undefined;

          if (hotelLevelRestrictions && hotelLevelRestrictions.length) {
            const lastRestriction = hotelLevelRestrictions[hotelLevelRestrictions.length-1];
            const extendedPropsRestriction = {
               RestrictionType: lastRestriction.RestrictionType,
               MinDays: lastRestriction.MinDays,
               MaxDays: lastRestriction.MaxDays,
               RateId: hotelSettings[lastRestriction.HotelID].selectedRate,
               RestrictionLevel: lastRestriction.RestrictionLevel,
               CreateDate: lastRestriction.CreateDate
            }
            const hotel = hotelsWithRooms.find(h => h.Id == lastRestriction.HotelID);

            rooms.forEach(room => {
              events.push({
                resourceId: room.Id,
                start: lastRestriction.Date,
                end: lastRestriction.Date,
                rendering: "background",
                allDay: true,
                editable: false,
                resourceEditable: false,
                overlap: true,
                extendedProps: {
                  hotel, restriction: extendedPropsRestriction
                },
                classNames: ["restriction"]
              })
            })
          }

          _.forEach(resdata, (restrictions, key) => {
            //no need to handle no roomtypeid values
            if (key == 'undefined') return;

            const [hotelId, roomtypeId] = key.split(':');
           
            restrictions.forEach(re => {
                const restriction = {
                RestrictionType: re.RestrictionType,
                MinDays: re.MinDays,
                MaxDays: re.MaxDays,
                RateId: re.RateId,
                RestrictionLevel: re.RestrictionLevel,
                CreateDate: re.CreateDate
              }

              const hotel = hotelsWithRooms.find(x=>x.Id == hotelId)

              const relevantrooms = _.filter(rooms, { TypeId: Number(roomtypeId), HotelId: Number(hotelId) })

              relevantrooms.forEach(room => {
                const eventToPush = {
                  resourceId: room.Id,
                  start: date,
                  end: date,
                  rendering: "background",
                  allDay: true,
                  editable: false,
                  resourceEditable: false,
                  overlap: true,
                  extendedProps: { hotel, restriction },
                  classNames: ["restriction"]
                }

                //check if the event all rdy was created
                const duplicateEventIndex = events.findIndex(r =>
                  r.resourceId === eventToPush.resourceId
                  && r.start === date);

                //if so replace it, else push a new one
                if (duplicateEventIndex > -1) {
                  //if rateId is undefined, no ovveride is allowed
                  if(shouldOverrideRestriction(eventToPush.extendedProps.restriction,events[duplicateEventIndex].extendedProps.restriction,hotelSettings[hotelId]))
                     {
                    events[duplicateEventIndex] = eventToPush;
                  }
                } else {
                  events.push(eventToPush)
                }
              })
            })
          })
        })
        events = events.filter(x => !x.extendedProps?.restriction || x.extendedProps.restriction.RestrictionType != RestrictionTypes.OpenRestrictionType);

        successCallback(events)
      } catch (error) {
        console.error(error)
        failureCallback(error)
      }
    } else {
      failureCallback()
    }
  }, [hotelSettings, hotels, hotelsWithRooms, rooms])

  const shouldOverrideRestriction = (currentRestriction,duplicateDateRestriction,settings) => {
      var isSameTimeOrNewer = currentRestriction.CreateDate >= duplicateDateRestriction.CreateDate;
      if(settings.selectedRate){
        return isSameTimeOrNewer;
      }
      else{
        return  isSameTimeOrNewer && currentRestriction.RestrictionLevel >= 2;//room type or hotel level
      }
  }

  const colDataFunction = useCallback(async (fetchInfo, successCallback, failureCallback) => {
    if (hotelsWithRooms.length) {
      try {
        const data = await Calendar.GetHotelDateParameters({
          HotelIds: hotelsWithRooms.map(x => x.Id),
          FromDate: fetchInfo.startStr,
          ToDate: fetchInfo.endStr
        })

        successCallback([{
          id: "columndata",
          display: "none",
          extendedProps: { data }
        }])
      } catch {
        failureCallback()
      }
    }
  }, [hotelsWithRooms])

  const priceDataFunction = useCallback(async (fetchInfo, successCallback, failureCallback) => {
    if (hotelsWithRooms.length) {

      try {
        const hotels = _.filter(hotelsWithRooms, hotel => {
          const settings = hotelSettings[hotel.Id]
          const showSettings = hotel.HotelFeatures.find(feature => feature.FeatureID === 12)
          return settings && settings.showPrices && showSettings
        })
        const promises = []
        hotels.forEach(hotel => {
          const settings = hotelSettings[hotel.Id]
          const roomtypes = _.uniq(rooms.filter(x => x.HotelId === hotel.Id).map(x => x.TypeId))
          roomtypes.forEach(roomTypeId => {
            promises.push(GetProductPricesForCalendar({
              HotelID: hotel.Id,
              StartDate: fetchInfo.startStr,
              EndDate: fetchInfo.endStr,
              RateID: settings && settings.selectedRate,
              RoomTypeID: roomTypeId
            }))
          })
        })
        const values = await Promise.all(promises)
        const events = []
        values.forEach(data => {
          data.forEach(pricedata => {
            const hotel = hotelsWithRooms.find(x=>x.Id == pricedata.HotelId)
            const relevantrooms = _.filter(rooms, { TypeId: pricedata.RoomTypeId, HotelId: pricedata.HotelId })
            relevantrooms.forEach(room => {
              events.push({
                resourceId: room.Id,
                start: pricedata.Date,
                end: pricedata.Date,
                rendering: "background",
                allDay: true,
                editable: false,
                resourceEditable: false,
                overlap: true,
                extendedProps: { hotel, pricedata },
                classNames: ["pricedata"]
              })
            })
          })
        })
        successCallback(events)
      } catch (error) {
        console.error(error)
        failureCallback(error)
      }
    } else {
      failureCallback()
    }
  }, [hotelSettings, hotelsWithRooms, rooms])

  const onEventClick = useCallback(info => {
    const event = info.event
    if (event) {
      if (event.extendedProps.IsGroupingDayUse || event.extendedProps.Virtual) {
        return
      } else {
        if (info.el) {
          info.el.classList.add("selected")
        }
        setSelected({
          el: info.el,
          event: event
        })
        var maintenance = event.extendedProps.maintenance;
        // Handle case where maintenance might be an array
        if (Array.isArray(maintenance)) {
          maintenance = maintenance[0];
        }
        if (maintenance && canEdit) {
          setMaintenanceForEdit(maintenance)
          setShowRoomMaintenance(true)
        } else if (event.extendedProps.reservation) {
          setShowInfo(true)
        }
      }
    }
  }, [canEdit])

  const onHideSidebar = (e) => {
    if (e == null || e.target.classList.contains("pusher")) {
      setShowInfo(false)
      if (selected && selected.el) {
        selected.el.classList.remove("selected")
        setSelected({})
      }
    }
    setReservationVisible(false)
  }

  const saveReservation = useCallback(async reservation => {
    // Clean propetries that should not be sent
    let saved = await SaveReservation(CleanReservationProps(reservation))
    return saved
  }, [])

  const updateReservationStatus = useCallback(async reservation => {
    let updated = await UpdateReservationStatus(reservation)
    return updated
  }, [])

  const onSelectDates = useCallback(selectInfo => {
    if (selectInfo.view.type !== "resourceTimelineDay") {
      selectInfo = {
        ...selectInfo,
        end: moment(selectInfo.end).subtract(1, 'day').toDate(),
        endStr: moment(selectInfo.end).subtract(1, 'day').toISOString(),
      }
    }
    setSelectionInfo(selectInfo)
    const defaultItem = localStorage.getItem("DefaultCalendarCreateItem")
    if (selectInfo.jsEvent.shiftKey || defaultItem === null) {
      setShowCreateMenu(true)
    } else if (defaultItem === "reservation") {
      createNewReservation(selectInfo)
    } else if (defaultItem === "maintenance") {
      createNewMaintenance(selectInfo)
    } else {
      setShowCreateMenu(true)
    }
  }, [])

  


  useEffect(() => {
    if (reservationForEdit) {
      setShowShortReservation(true)
    }
  }, [reservationForEdit])

  useEffect(() => {
    if (maintenanceForEdit) {
      setShowRoomMaintenance(true)
    }
  }, [maintenanceForEdit])

  const onCreateUpdate = async reservations => {
    let totals = []
    if (_.some(reservations, x => !x.MaintenanceStatusTypeId)) {
      totals = _.flatMap(await Promise.all(_.map(_.groupBy(reservations, "HotelId"), (reservations, HotelId) => {
        const hotel = hotels.find(x=>x.Id == HotelId)
        return GetReservationTotals({
          ReservationIDs: _.map(reservations, "Id"),
          HotelId: HotelId,
          TargetCurrencyID: hotel && hotel.MainCurrencyId
        })
      })))
    }

    const events = window.calendar.getEvents()
    const existing = events.find(item => item.id == reservations[0].Id)
    if (!existing) { // Creating new
      const hotel = selectionInfo ? selectionInfo.resource.extendedProps.hotel : hotels.find(item => item.Id === reservations[0].HotelId)
      const room = selectionInfo ? selectionInfo.resource.extendedProps.room : rooms.find(item => item.Id === reservations[0].RoomId)
      reservations.forEach(reservation => {
        let event
        if (reservation.MaintenanceStatusTypeId) { // Handle maintenance event 
          event = {
            id: reservation.Id,
            resourceId: reservation.RoomId,
            title: reservation.Description ? reservation.Description.replaceAll("\n", " ") : MaintenanceStatusTypes[reservation.MaintenanceStatusTypeId],
            start: moment(reservation.StartDate).hour(12).toISOString(),
            end: moment(reservation.EndDate).hour(12).toISOString(),
            extendedProps: { maintenance: reservation, hotel: hotel, room: room },
            classNames: "maintenance",
            color: reservation.Color,
            textColor: getContrastYIQ(reservation.Color || "3788d8")
          }
        } else {
          const title = viewSettings.showReservationNumber ? `${reservation.Number} ${GetFullName(reservation.Guest)}` : GetFullName(reservation.Guest)
          const rescheckin = reservation.ActualCheckinDate || reservation.CheckInDate
          const rescheckout = reservation.ActualCheckoutDate || reservation.CheckOutDate
          event = {
            id: reservation.Id,
            resourceId: reservation.RoomId,
            title: title,
            start: rescheckin,
            end: rescheckout,
            extendedProps: { reservation: reservation, hotel: hotel, room: room, totals: totals.find(x=>x.ReservationID == reservation.Id) },
            color: reservation.Color,
            textColor: getContrastYIQ(reservation.Color || "3788d8"),
            classNames: ["selected"]
          }
        }
        window.calendar.addEvent(event)
        if (!reservation.MaintenanceStatusTypeId) {
          _.defer(() => {
            const el = document.querySelector(`[data-event-id='${event.id}']`)
            onEventClick({
              event,
              el
            })
          })
        }
      })
    } else if (selected) { // Updating existing
      reservations.forEach(reservation => {
        //let event = selected.event
        // Make sure event belongs to the correct calendar
        let event = window.calendar.getEventById(reservation.Id)
        selected.event = event
        if (reservation.MaintenanceStatusTypeId) { // Handle maintenance event 
          if (!reservation.IsActive) {// Deleted event, remove from calendar
            event.remove()
          } else {
            event.setProp("title", reservation.Description ? reservation.Description.replaceAll("\n", " ") : MaintenanceStatusTypes[reservation.MaintenanceStatusTypeId])
            event.setDates(moment(reservation.StartDate).hour(12).toISOString(), moment(reservation.EndDate).hour(12).toISOString())
            event.setExtendedProp("maintenance", reservation)
          }
        } else {
          if ([ReservationStatusesEnums.Cancelled, ReservationStatusesEnums.Deleted].includes(reservation.StatusId)) {
            // Remove any events representing the reservation
            const elms = document.querySelectorAll(`[data-event-id^='${reservation.Id}']`)
            elms.forEach(x => {
              const eid = x.attributes["data-event-id"].value
              if (eid) {
                window.calendar.getEventById(eid).remove()
              }
            })
          } else {
            const title = viewSettings.showReservationNumber ? `${reservation.Number} ${GetFullName(reservation.Guest)}` : GetFullName(reservation.Guest)
            event.setProp("title", title)
            event.setProp("color", reservation.Color)
            event.setProp("textColor", getContrastYIQ(reservation.Color || "39c2e1"))
            event.setDates(reservation.CheckInDate, reservation.CheckOutDate)
            event.setResources([reservation.RoomId])
            event.setExtendedProp("reservation", reservation)
            event.setExtendedProp("totals", totals.find(x=>x.ReservationID == reservation.Id))
            event.setProp("classNames", ["selected"])
          }
        }
        //if non day use event changed to day use event - need to make day use event for it
        if (moment(reservation.CheckInDate).utc().isSame(moment(reservation.CheckOutDate).utc(), "day")) {
          const events = window.calendar.getEvents()
          // search for dayuse reservations
          let dayuse = events.filter(x =>
            x.extendedProps.reservation && moment(x.start).isSame(moment(x.end), "day")
            && moment(x.start).isSame(moment(reservation.CheckInDate), "day")
            && x.extendedProps.reservation.RoomId === reservation.RoomId
          )

          dayuse = _.groupBy(dayuse, x => `${moment(x.start).format("YYYY-MM-DD")}:${(x.resourceId || x.extendedProps.reservation.RoomId)}`)

          _.forEach(dayuse, (val, key) => {
            const [date, resourceId] = key.split(":")
            window.calendar.addEvent({
              id: key,
              resourceId: Number(resourceId),
              title: `${val.length} ${text("Reservations")}`,
              start: moment(date).startOf("day").toISOString(),
              end: moment(date).startOf("day").toISOString(),
              className: "grouping-event",
              durationEditable: false,
              startEditable: false,
              resourceEditable: false,
              extendedProps: { events: val, IsGroupingDayUse: true }
            })
          })
        }
        else {
          //if a day use event became a regular event, the day use event for it need to change
          const events = window.calendar.getEvents()

          // search for dayuse reservations in which the reservation in the extended props in no longer day use
          let dayUseToRemove = events.find(x =>
            x.extendedProps.events && x.extendedProps.IsGroupingDayUse && x.extendedProps.events.find(ev => ev.id == reservation.Id)
          )

          if (dayUseToRemove) {
            const eventToRemove = window.calendar.getEventById(dayUseToRemove.id)
            eventToRemove.remove()

            // search for dayuse events to recalc them for this resourceId and date 
            let dayuse = events.filter(x =>
              x.extendedProps.reservation && moment(x.start).isSame(moment(x.end), "day")
              && moment(dayUseToRemove.start).isSame(moment(x.end), "day")
              && x.extendedProps.reservation.RoomId === reservation.RoomId
            )

            dayuse = _.groupBy(dayuse, x => `${moment(x.start).format("YYYY-MM-DD")}:${(x.resourceId || x.extendedProps.reservation.RoomId)}`)

            _.forEach(dayuse, (val, key) => {
              const [date, resourceId] = key.split(":")
              window.calendar.addEvent({
                id: key,
                resourceId: Number(resourceId),
                title: `${val.length} ${text("Reservations")}`,
                start: moment(date).startOf("day").toISOString(),
                end: moment(date).startOf("day").toISOString(),
                className: "grouping-event",
                durationEditable: false,
                startEditable: false,
                resourceEditable: false,
                extendedProps: { events: val, IsGroupingDayUse: true }
              })
            })
          }

        }
      })
      setSelected({ ...selected })
    }
    _.defer(rebuildDayUseEvents)
    _.defer(rebuildVirtualEvents)
  }

  const onClosePopup = () => {
    setShowShortReservation(false)
    setShowRoomMaintenance(false)

    setSelectionInfo(null)
    if (selected.event && selected.event.extendedProps.maintenance) {
      selected.el.classList.remove("selected")
      setSelected({})
    }
  }

  const onChangeRestictions = () => {
    if (window.calendar && window.calendar.getEventSourceById) {
      window.calendar.getEventSourceById("daydata")?.refetch()
    }
  }
  const onChangePrices = () => {
    if (window.calendar && window.calendar.getEventSourceById) {
      window.calendar.getEventSourceById("pricedata")?.refetch()
    }
  }

  if (hotels) {
    return (
      <React.Fragment>
        <Sidebar.Pushable className="tapechart">
          <Sidebar
            visible={showInfo}
            width="wide"
            animation='overlay'
            onHide={onHideSidebar}
            onShow={() => setReservationVisible(true)}
            as={Segment}
            direction="right"
            className={`reservation ${isMobileOnly ? "mobile" : ""}`}>
            <ReservationInfo
              selection={selected}
              saveReservation={saveReservation}
              updateReservationStatus={updateReservationStatus}
              setShowInfo={setShowInfo}
              closePanel={() => setShowInfo(false)}
              openShortReservation={setReservationForEdit}
              rebuildVirtualEvents={rebuildVirtualEvents}
              rebuildDayUseEvents={rebuildDayUseEvents}
              onCreateUpdate={onCreateUpdate}
              reservationVisible={reservationVisible}
            />
          </Sidebar>
          <Sidebar.Pusher
            dimmed={showInfo}>
            <Scheduler
              eventClick={onEventClick}
              eventsFunction={eventsFunction}
              resourcesFunction={resourcesFunction}
              dayDataFunction={dayDataFunction}
              priceDataFunction={priceDataFunction}
              colDataFunction={colDataFunction}
              saveReservation={saveReservation}
              updateReservationStatus={updateReservationStatus}
              select={onSelectDates}
              setViewSettings={setViewSettings}
              viewSettings={viewSettings}
              setHotelSettings={setHotelSettings}
              hotelSettings={hotelSettings}
              hotels={hotels}
              rebuildVirtualEvents={rebuildVirtualEvents}
              rebuildDayUseEvents={rebuildDayUseEvents}
              HotelFilterCmp={HotelFilterCmp}
            />
          </Sidebar.Pusher>
        </Sidebar.Pushable>
        
        <Modal open={showCreateMenu} onClose={() => setShowCreateMenu(false)} size="mini" >
          <Modal.Header>
            {text("CreateNew")}
          </Modal.Header>
          <Modal.Content>
            <Menu vertical fluid>
              <Menu.Item link onClick={()=>createNewReservation(selectionInfo)}> {text("Reservation")}</Menu.Item>
              <Menu.Item link onClick={()=>createNewMaintenance(selectionInfo)}> {text("Maintenance")}</Menu.Item>

            </Menu>
            <Divider />
            <Menu vertical fluid secondary>
              <Menu.Item link onClick={()=>createRestrictions(selectionInfo)}> {text("UpdateRestrictions")}</Menu.Item>
              <Menu.Item link onClick={()=>createPriceUpdate(selectionInfo)}> {text("PricesUpdate")}</Menu.Item>
            </Menu>
            <Checkbox checked={selectionAsDefault} onChange={(e, { checked }) => setSelectionAsDefault(checked)} label={text("SetSelectionAsDefault")}></Checkbox>
            {selectionAsDefault && <Message info>{text("RevertDefaultSelectionByHoldingCtrl")}</Message>}
          </Modal.Content>
        </Modal>

        <ValidateModalPermission open={showShortReservation} onClose={onClosePopup} actionId={PermissionsActions.ViewShortReservation}>
          <ShortReservationPopup
            open={showShortReservation}
            reservation={reservationForEdit}
            onClose={onClosePopup}
            onSave={onCreateUpdate} />
        </ValidateModalPermission>

        <RoomMaintenancePopup open={showRoomMaintenance} maintenance={maintenanceForEdit} onClose={onClosePopup} onSave={onCreateUpdate} />
        {(isMobileOnly && canEdit && !showInfo) && <Fab alwaysShowTitle={true} event="click" style={{ margin: 10, bottom: 0, right: 0 }} icon={
          <Icon fitted name="plus" />
        } mainButtonStyles={{ backgroundColor: "#01a7bd" }}>
          <Action text={`${text("CreateNew")} ${text("Maintenance")}`} onClick={() => createNewMaintenance({})}>
            <Icon name="wait" fitted size="large" />
          </Action>
          <Action text={`${text("CreateNew")} ${text("Reservation")}`} onClick={() => createNewReservation({})}>
            <Icon name="calendar plus outline" fitted size="large" />
          </Action>
        </Fab>}
        <RestrictionsPopup controller="RestrictionsController" onSave={onChangeRestictions} />
        <PriceUpdatePopup controller="PriceUpdateController" onSave={onChangePrices} />
      </React.Fragment>
    )
  } else {
    return null
  }

}

export default TapeChart